import { transformDropOffPrintIcon } from './drop-off-print-icon';
export const transformDropOffTypeMeta = _ref => {
  let {
    icon_url,
    confirm_title,
    confirm_message,
    secondary_title,
    confirm_selection_title,
    cancel_selection_title,
    print_icon
  } = _ref;
  return {
    iconUrl: icon_url,
    confirmTitle: confirm_title,
    confirmMessage: confirm_message,
    secondaryTitle: secondary_title,
    confirmSelectionTitle: confirm_selection_title,
    cancelSelectionTitle: cancel_selection_title,
    dropOffPrintIcon: print_icon ? transformDropOffPrintIcon(print_icon) : null
  };
};
export const transformDropOffType = _ref2 => {
  let {
    id,
    instructions,
    key,
    subtitle,
    title,
    drop_off_type_meta,
    pick_up_date_shown,
    pick_up_time_shown
  } = _ref2;
  return {
    id,
    instructions,
    key,
    subtitle,
    title,
    dropOffTypeMeta: transformDropOffTypeMeta(drop_off_type_meta),
    pickUpDateShown: pick_up_date_shown,
    pickUpTimeShown: pick_up_time_shown
  };
};
export const transformDropOffTypes = data => data.map(transformDropOffType);